// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2200":"2d8b52bd","5113":"2d8b52bd","7489":"2d8b52bd","8576":"2d8b52bd"}[chunkId] + ".chunk.css";
};